import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, FormBuilder, FormArray} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CentroAlmacen } from '../../../traslado-logist/model/asignacion-centro.model';
import { ITiposViajesShort, ITrackingViajes } from '../../model/modelTracking';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import { Placa } from 'src/app/model/datos-maestros/placa';
import { Chofer } from '../../../traslado-logist/model/model';
import { OrdenBalanzaService } from 'src/app/aplicaciones-modulos/balanza/services/orden-balanza.service';
import { IOrdenBalanza } from 'src/app/aplicaciones-modulos/balanza/modelos/IOrdenBalanza';
import { TicketAutorizacionTransporteService } from 'src/app/aplicaciones-modulos/balanza/services/ticket-autorizacion-transporte.service';
import { IAreaLogistica, ITiposPlanificacion } from '../../model/modelConfiguracional';
import { ColDef, ColGroupDef, GridApi, GridOptions, RowHeightParams} from 'ag-grid-community';
import { ClaveValorModel } from 'src/app/model/datos-maestros/claveValorModel';
import { forkJoin, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { TrackingConfiguracionService } from '../../service/trackingConfiguracion.services';
import { MantenimientoOrigenesExtractorasService } from 'src/app/aplicaciones-modulos/balanza/services/mantenimiento-origenes-extractoras.service';
import { UsuarioBasculaGaritaService } from 'src/app/aplicaciones-modulos/balanza/services/usuario-bascula-garita.service';
import { TipoOrdenesBalanzaService } from 'src/app/aplicaciones-modulos/balanza/services/tipo-ordenes-balanza.service';
import { OnlyControlService } from 'src/app/aplicaciones-modulos/spyral/services/only-control.service';
import { EquiposMarquesinaService } from '../../service/equiposMarquesinas.service';
import { IBasculaSentidoRequest, IMensajeMarquesina, IMensajesRequest, IResponseApiOnlyServices } from '../../model/modelOnlyServices';
import { ReportesSeguimientoModule } from 'src/app/aplicaciones-modulos/vdi/reportes-seguimiento/reportes-seguimiento.module';
import {ClienteShort} from "../../../../model/datos-maestros/cliente-short";
import { dateNotPastValidator } from 'src/app/utils/validators';

@Component({
  selector: 'app-tracking-planificacion',
  templateUrl: './tracking-planificacion.component.html',
  styleUrls: ['./tracking-planificacion.component.css']
})

export class TrackingPlanificacionComponent implements OnInit {
  public DAT_TITULOS    = diccionarios.titulos.planificacion;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID    = diccionarios.agGrid;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = false;

  // variables para el grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public rowData        : ITrackingViajes[] = [];
  public rowSelection   : any;
  public gridApi        : GridApi;
  public gridColumnApi  : any;
  public textoBuscar    : string;
  public usarioActual   : any;

  public pageSize       : number = 17;
  public rowModelType   : string = 'clientSide';
  public datasource     : any = {
    getRows: (params: any) => {
      const page = Math.floor(params.startRow / this.pageSize);
      this.loading = true;
      this.logisticaAPI.getViajesFindAllQuery(this.textoBuscar || '', page, this.pageSize)
        .subscribe((res: any) => {
          this.loading = false;
          if (res) {
            params.successCallback(res.content, res.totalElements);
          } else {
            params.successCallback([], 0);
          }
        }, (err) => {
          this.loading = false;
          console.error(err.message);
          params.failCallback();
        });
    }
  };

  // variables funcionales
  public listCentros    : CentroAlmacen [] = [];
  public LISTA_CENTO_DESTINO: Array<{ id: string; descripcion: string }> = [];
  public listTipos      : ITiposViajesShort  [] = [];
  public listTipos1     : ITiposPlanificacion [] = [];
  public listAreas      : IAreaLogistica[] = [];
  public listAgencias   : any[] = [];
  public listFurgones   : Placa [] = [];
  public cmbxEstados    : ClaveValorModel[] = [];

  get permiteDigitarFurgon(): boolean {
    const esExporta = this.tipoSelected?.nombre?.toUpperCase().includes('EXPORTA') ?? false;
    const proveedorEspecial = this.formulario?.get('proveedorId')?.value == '100053941';
    return esExporta || proveedorEspecial;
  }

  addTagFurgon = (term: string): any => {
  const partes = term.trim().split(/\s+/);
  const placa = partes[0] || term;
  const tipoRecurso = this.formulario?.get('tipoRecurso')?.value;
  const tipoLabel = tipoRecurso ? ` (${tipoRecurso})` : '';
  const marca = partes.length > 1
    ? `${placa} - ${partes.slice(1).join(' ')}${tipoLabel}`
    : `${placa}${tipoLabel}`;
  return { placa, marca };
};

  tagFurgonManualEdicion = (placa: string, detalle?: string): any => {
    const tipoRecurso = this.formulario?.get('tipoRecurso')?.value;
    const tipoLabel = tipoRecurso ? ` (${tipoRecurso})` : '';
    const marca = detalle ? `${placa} - ${detalle}${tipoLabel}` : `${placa}${tipoLabel}`;
    return { placa, marca };
  };
  public routear        : "planificador";
  public selected       : ITrackingViajes;
  public tipoSelected   : ITiposPlanificacion;
  public fechaHoraInicio: any;

  public isBalanza      : boolean = false;
  public requireCliente : boolean = false;
  public isEditor       : boolean = false;
  public permiteEditar  : boolean = true;
  public conexionSensores: boolean = false;
  public isVntContenerizada: boolean= false; //T.42031 RF: 1.6 1.7 
  public isConsulta    : boolean = false;


  //Formularios
  public formulario     : FormGroup;
  public isFocus        : boolean = true;

  public formBalanza = new FormGroup({
    idViaje       : new FormControl(''),
    balanzaTicket : new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
    pesoIn        : new FormControl('', Validators.required),
    pesoOut       : new FormControl(''),
    garitaTicket  : new FormControl(''),
    fSalidaGarita : new FormControl(''),
    balanzaFechaInicio: new FormControl(''),
    balanzaFechaFin: new FormControl(''),
    estado        : new FormControl('', Validators.required),
    estadoOB      : new FormControl('', Validators.required),
    modificadoPor : new FormControl(''),
    });

    clienteElegido: ClienteShort | undefined;
    placas: any[] = [];
    placasLoading = false;
    public formFiltro ;

  constructor(
    private fbServices      : FormBuilder,
    private utilServices    : UtilsService,
    private dmaestrosAPI    : DatosMaestrosService,
    private logisticaAPI    : LogisticaService,
    private _catalogos      : CatalogosLogisticaService,
    private rutaActiva      : ActivatedRoute,

    private balanzaAPI      : OrdenBalanzaService,
    private ticketGaritaApi : TicketAutorizacionTransporteService,
    private trackingConfiguracional: TrackingConfiguracionService,
    private balanzaAPIExtractoras: MantenimientoOrigenesExtractorasService,
    private usuarioBasculaAPI    : UsuarioBasculaGaritaService,
    private tipoOrdenesBalanzaS: TipoOrdenesBalanzaService,

    /**Integracion de servicios con equipos y sensores */
    private onlyControlSensoresAPI: EquiposMarquesinaService,
  ) { }

  ngOnInit(): void {
    this.formFiltro = this.fbServices.group({
      fechaInicio   : [null],
      fechaFin      : [null],
      proveedorId   : [null],
      centroDestino : [null],
      tipo          : [null],
    });

    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.titleModal = this.DAT_TITULOS.tituloCardList;
    this.isCreate = false;
    this.conexionSensores = false;
    this.rutaActiva.params.subscribe((params: Params) => {
      console.log('Router-Params: ' + params.aprobar);
      this.isBalanza = params.proceso == "balanza";
      this.isConsulta = params.proceso == "consulta";

      if(this.isBalanza) this.DAT_TITULOS = diccionarios.titulos.balanza;

      this.rowModelType = this.isBalanza ? 'clientSide' : 'infinite';
    });

    // false si es modelo nuevo.
    // Descontinuado funacion por ampliacion de funcionalidad, proceso de Cristhian
    this.isFocus = true;

    this.formulario = this.fbServices.group({
      idViaje       : [''],
      tipo          : ['', Validators.required],
      proveedorId   : ['', [Validators.required, Validators.minLength(9), Validators.maxLength(9), Validators.pattern('^[0-9]*$')]],
      proveedorNombre:['', Validators.required],
      choferCedula  : ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      choferNombre  : ['', Validators.required],
      choferTelefono: ['', [Validators.required, Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      placa         : ['', [Validators.required, Validators.maxLength(10)]],
      furgon        : ['', [Validators.required, Validators.maxLength(15)]],
      centroOrigen  : ['', [Validators.required, Validators.maxLength(4)]],
      bodegaCarga   : ['', [Validators.required, Validators.maxLength(4)]],
      fechaLlegada  : ['', [Validators.required, dateNotPastValidator]],
      observacion   : ['', Validators.maxLength(250)],
      estado        : [''],
      centroDestino : ['', [Validators.required]],
      creadoPor     : [''],
      modificadoPor : [''],
      balanzaTicket : [''],
      garitaTicket  : [''],
      detallePlaca  : ['', Validators.required],
      detalleFurgon : [''],
      tipoRecurso   : [''],

      //Aplica a todos
      almacenDestino: [''],
      areaId      : [''],
      tipoServicio: [''], // Cristhian debe verificar si es necesiario o se setea un tipo por defecto cuando viene desde la planificacion
      tipoCarga   : ['', Validators.required],
      prioridad   : ['', Validators.required],
      materialId  : ['', Validators.maxLength(10)],
      materialRef : [''],
      aplicaSalidaDevolucion  : [false],    // si aplica salida posterior o devolución

      orden       : [''],
      buque       : [''],
      tanquero    : [''],

      cliente       : ['', [Validators.maxLength(10)]],
      clienteNombre : [''],
      cantidadDespacho  : [''],
      tipoOrdenBalanza  : [''],
      fechaInicioProceso: [],
      extractoraPesoNeto  : [''],
      extractoraPesoBruto : [''],
      extractoraPesoTara  : [''],
    });

    this.manejarControlCompras('COMPRA');// Inicializa campos dinamicos

    /**SUSBCRIPCION A EVENTOS CHANGES */
    this.formulario.get('tipo').valueChanges.subscribe(valor => {
      if(valor != null){
        console.log("tipo seleccionado", valor);
        this.tipoSelected   = this.listTipos1.find(e=> e.idTipo == valor);
        //this.requireCliente = this.tipoSelected.reqCliente;
        const PRIORIDAD     = this.listCatalogos.prioridades.find(e=> e.valor == this.tipoSelected.prioridadKanban);
        this.formulario.get('prioridad')?.setValue(PRIORIDAD.clave);
        this.manejarControlCompras(this.tipoSelected.tipoEscenario);

        //VALIDACION PARA INTEGRACION BALANZA - ONLY CONTROLS
        if(this.tipoSelected.generaTicketBalanza){
          this.getUsuarioBasculaGarita();
        }

      }
    });

    this.formulario.get('choferCedula').valueChanges.subscribe(valor => {
      if(valor != null && this.isCreate){
        this.formulario.get('choferTelefono').reset();
        this.formulario.get('choferTelefono').setValue(
        this.listChoferes.filter(e=>e.cedula == valor)[0].fono);
      }
    });

    this.formulario.get('centroDestino').valueChanges.subscribe(valor => {
      if(valor != null && this.tipoSelected.tipoEscenario !='VENTA') this.getAreas();
    });

    this.formulario.get('centroOrigen').valueChanges.subscribe(valor => {

      if (valor)  this.getAlmacenByCentroUser(valor);

      if(valor != null && (this.tipoSelected.tipoEscenario =='VENTA' || this.tipoSelected.tipoEscenario =='TRASLADO'))
        this.getAreas();
    });

    this.formulario.get('tipoCarga').valueChanges.subscribe(valor => {
      if(valor != null){
        this.formulario.get('extractoraPesoNeto').reset();
        //T.42031 RF: 1.6 1.7 
        this.isVntContenerizada = this.tipoSelected.tipoEscenario == "VENTA" && valor == 1;
      }
    });

    this.cargarGridcomponent();
    this.inicializar();
    this.formBalanza.get('pesoOut')?.disable({ onlySelf: true });
  }

  //GETTER
  get comprasControl() {
    return this.formulario.get('compras') as FormGroup;
  }

  get tipoCarga() {
    return this.formulario.get('tipoCarga').value;
  }

  get tipoPlanificacion() {
    return this.formulario.get('tipo');
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = this._catalogos.getColumnDefs();
    this.columnDefs.push(
      { cellRenderer: 'buttonRenderer', initialPinned:"left",  width:80, cellRendererParams: {onClick: this.editar.bind(this), label: 'Editar'} },
    );

    if(this.isBalanza){
      this.columnDefs.push(
      { cellRenderer: 'buttonRenderer', initialPinned:"left",  width:150, cellRendererParams: {onClick: this.procesoBalanza.bind(this), label: 'Iniciar bascula'} },
      { cellRenderer: 'buttonRenderer', initialPinned:"left",width: 80, cellRendererParams: {onClick: this.imprimirDoc.bind(this), label: 'T. Salida'} },
    )
    }

    if(!this.isBalanza){
      this.columnDefs.push(
      { cellRenderer: 'buttonRenderer', initialPinned:"left",  width:100, cellRendererParams: {onClick: this.actualizarEstado.bind(this), label: 'A revisión', disabled: (data) => data?.estado !== 'CREADO'} },
      { cellRenderer: 'buttonRenderer', initialPinned:"left",  width:80, cellRendererParams: {onClick: this.delete.bind(this), label: 'Eliminar'} }
    )
    }
    //Ver Bitacora
    this.columnDefs.push(
      { cellRenderer: 'buttonRenderer', initialPinned:"left",  width:80, cellRendererParams: {onClick: this.getBitacora.bind(this), label: 'Ver'} },
    );

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    if (this.isBalanza) {
      this.gridApi?.setQuickFilter(this.textoBuscar);
      return;
    }
    if (this.gridApi?.purgeInfiniteCache) {
      this.gridApi.purgeInfiniteCache();
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (!this.isBalanza) {
      this.listar();
    }
  }

  listCatalogos;
  listOrigen;
  listOrigenAll;
  inicializar(){
    this.listTipos    = [];
    this.listCentros  = [];
    this.LISTA_CENTO_DESTINO = [];
    this.cmbxEstados  = this._catalogos.catalogoEstados();

    const _getAllCentros = this.dmaestrosAPI.getAllCentroLogistico();
    const _getAllTipos   = this.trackingConfiguracional.getAllTipos();
    const _getAllCatalogos= this.trackingConfiguracional.getAllCatalogos();
    const _getAllOrigenes = this.balanzaAPIExtractoras.obtener();

    forkJoin([_getAllCentros, _getAllTipos, _getAllCatalogos, _getAllOrigenes]).subscribe((res: any) => {
      //this.listCentros = res[0];
      //this.listCentros.map(centros => { centros.nombre = centros.id + ' - ' + centros.nombre; });
      this.listTipos1 = res[1];
      this.listCatalogos = res[2];
      this.listOrigenAll = res[3];
      if(res[3])this.listOrigenAll.map(e => { e.descripcion = e.proveedor + ' - ' + e.descripcion; });
      this.loading = false;
    }, () => {
      this.loading = false;
    });

    this.getCentrosByUser();
    this.cargarCentrosDestinos();

    this.logisticaAPI.getTipos().subscribe((res) => {
      if(res) this.listTipos = res;
    }, (err) => {
      console.log(err.message);
    });

    if(this.isFocus){
      this.formBalanza.get('areaId')?.clearValidators();
      this.formBalanza.get('areaId')?.updateValueAndValidity({ emitEvent: false });
    }

    this.listar();
    this.getTipoOb();
    this.getAllMensajesMarquesinas(); //Aplica para mensajes de marquesinas
  }

  getAllCentros(){
    this.dmaestrosAPI.getAllCentroLogistico().subscribe((res) => {
      if(res)this.listCentros = res.map((e)=> {e.nombreCentro = e.idCentro +" - "+e.nombreCentro; return e});
    }, (err) => {
      console.log(err.message);
    });
  }

  getCentrosByUser(){
    this.logisticaAPI.getConfigTrasladosCentroOrigen(this.usarioActual.id).subscribe((res) => {
      if (Array.isArray(res) && res.length > 0) {
        console.log("fill config centro by user");
        this.listCentros = res.map((e)=> {e.nombreCentro = e.idCentro +" - "+e.nombreCentro; return e});
      } else {
        console.log("fill config centro all");
        this.getAllCentros();
      }
    }, (err) => {
      //if (err?.status === 404) {
        console.log("fill config centro all");
        this.getAllCentros();
      //  return;
     // }
      console.log(err.message);
    });
  }

  cargarCentrosDestinos() {
    this.logisticaAPI.getParametrosLogisticaName('TRACK_GENRL_CENTRO_DESTINO').subscribe((res: any) => {
      let hijos: any[] = [];
      if (Array.isArray(res)) {
        const hijosFromParents = res.flatMap((r: any) => Array.isArray(r?.parametrosHijos) ? r.parametrosHijos : []);
        hijos = hijosFromParents.length ? hijosFromParents : res;
      } else if (Array.isArray(res?.parametrosHijos)) {
        hijos = res.parametrosHijos;
      }

      this.LISTA_CENTO_DESTINO = (hijos || [])
        .map((e: any) => ({
          id: e?.nombreParametro,
          descripcion: e?.descripcionParametro ?? e?.nombreParametro
        }))
        .filter((e: any) => !!e.id);

       console.log("LISTA_CENTO_DESTINO ->", this.LISTA_CENTO_DESTINO);

    }, (err) => {
      console.log(err.message);
      this.LISTA_CENTO_DESTINO = [];
    });
  }

  getAlmacenByCentroUser( eventOrValue: any){
    console.log("getAlmacenByCentroUser ->", eventOrValue);

    let idCentro;

    if (eventOrValue?.target) {
      idCentro = eventOrValue.target.value;
    } else {
      idCentro = eventOrValue;
    }

    this.listAgencias = [];
    this.logisticaAPI.getConfigTrasladosAlmacenOrigen(this.usarioActual.id, idCentro).subscribe((res) => {
      if (Array.isArray(res) && res.length > 0) {
        console.log("fill config almacen by user");
        this.listAgencias = res.map(e => {e.dscaAlmacen = e.idAlmacen + ' - ' + e.dscaAlmacen; return e;});
        this.listAgenciasDestino = this.ensureAlmacenDestinoPT01(this.listAgencias);
      } else {
        console.log("fill config almacen all");
        this.getAlmacen();
      }
    }, (err) => {
      //if (err?.status === 404) {
        console.log("fill config almacen all");
        this.getAlmacen();
      // return;
     // }
      console.log(err.message);
    });
  }

  //Funciones del CRUD
  nuevo() {
    this.isCreate   = true;
    this.selected   = null;
    this.permiteEditar= true;
    this.titleModal   = this.GLOBAL_TITULOS.tituloAgregar;
    this.fechaHoraInicio = this.utilServices.getFechayHoraActual();

    this.formulario.reset();
    this.formulario.get('creadoPor').setValue(this.usarioActual.login2);
    this.formulario.get('estado').setValue("CREADO");
    this.listOrigenAll = this.listOrigenAll.filter(item => item.estado == 'ACTIVO');
    //this.formulario.get('areaId').setValue("0");
    //this.openModal();
  }

  async editar({rowData}){
    this.isCreate         = true;
    this.selected         = rowData;
    this.permiteEditar    = rowData.estado == 'CREADO' || rowData.estado == 'EN_RUTA' || rowData.estado == 'EN_COLA'
    this.titleModal       = this.GLOBAL_TITULOS.tituloActualizar;
    this.fechaHoraInicio  = this.utilServices.getFechayHoraActual();
    //this.tipoSelected   = this.listTipos1.find(e=> e.idTipo == rowData.tipoOrdenBalanza);

    this.formulario.reset();
    this.formulario.patchValue(rowData);
    this.formulario.get('modificadoPor').setValue(this.usarioActual.login2)

    //this.openModal();
    this.getProveedor();
    this.getChofer();
    this.getAlmacen();
    await this.getPlaca();
    this.getPlaca(false);
    await this.getFurgonByCodePlaca();
    //await this.getTipoOb();
    console.log("tOB->" ,this.cmbTipoOrden);
    console.log("rowData->", rowData);

    //Valores cuando aplica origen y compras
      this.formulario.get('compras.proveedorCompra')?.setValue(rowData.proveedorCompra);
      this.formulario.get('compras.extractoraId')?.setValue(rowData.extractoraId);
      this.formulario.get('compras.extractoraAcidez')?.setValue(rowData.extractoraAcidez);
      this.formulario.get('compras.extractoraHumedad')?.setValue(rowData.extractoraHumedad);
      this.formulario.get('compras.extractoraImpureza')?.setValue(rowData.extractoraImpureza);
      this.formulario.get('aplicaSalidaDevolucion')?.setValue(rowData.aplicaSalidaDevolucion ? 1: 0);
      this.formulario.get('tipoOrdenBalanza')?.setValue(Number(rowData?.tipoOrdenBalanza));

      //this.manejarControlCompras('COMPRA');
      //getAlmacen espera esOrigen, getProveedor esProveedorTransporte
      if(rowData.almacenDestino != null) this.getAlmacen(false);
      if(rowData.proveedorCompra != null) this.getProveedor(false);
  }

  delete({rowData}){
    this.loading = true;

    this.utilServices.confirmarSincronoPromesa({
        title : diccionarios.mensajes.eliminar,
        text  : this.GLOBAL_TITULOS.tituloEliminar,
        action: "Eliminar",
        funcion: this.logisticaAPI.deleteViaje(rowData.idViaje),
      })
      .then((_res: any) => {
        this.listar();
      })
      .catch(() => {
        this.loading = false;
      });

    this.loading = false;
  }

  listar(){
    this.rowData = null;
    if(!this.isBalanza){
      this.loading = true;
      if (this.gridApi) {
        this.gridApi.setDatasource(this.datasource);
      }
      return;
    }
    this.logisticaAPI.getViajesByEstadosBalanza().subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => {
      console.info(err.message);
    });
  }

  /** Si el form esta en modo de creación hará post caso contrario un put.
   * Ver variable isCreated */
  saveForm() {
    this.getFormValidationErrors();
    if (this.formulario.invalid) return;

    this.loading  = true;
    let data = this.formulario.getRawValue();
    data.fechaInicioProceso = this.fechaHoraInicio;

    if(this.tipoSelected.tipoEscenario == 'COMPRA'){
      data.proveedorCompra  = data.compras?.proveedorCompra;
    }

    if(this.tipoSelected.requiereOrigen){
      data.extractoraId     = data.compras?.extractoraId;
      data.extractoraAcidez = data.compras?.extractoraAcidez;
      data.extractoraHumedad  = data.compras?.extractoraHumedad;
      data.extractoraImpureza = data.compras?.extractoraImpureza;
    }

    const payload =  data;

   //validia si data.idViaje  es null o vacio es es actualizacion
    // Si data.idViaje es null o vacío es creación, caso contrario actualización
    const esCreacion = !data.idViaje;

    let mensajeP  = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;
    console.log("datos a enviar", data);
    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : esCreacion ? this.logisticaAPI.createViaje(payload) : this.logisticaAPI.updateViaje(payload)
      }).then(() => {
        this.listar();
        this.isCreate = false;
        this.isBalanza = false;
        this.selected = null;
        
        this.conexionSensores = false;
        this.titleModal = this.DAT_TITULOS.tituloCardList;
        this.closeModal();
      }).catch(() => {});

      this.loading = false;
  }

  saveFormBalanza() {
    if (this.formBalanza.invalid) return;

    this.loading  = true;
    let balanza = this.formBalanza.getRawValue();
    balanza.fechaInicioProceso = this.fechaHoraInicio;

    if(this.selected.estado == 'BALANZA_OUT'){
      this.utilServices.mensajeOKToast("Balanza Salida, pasará a ASIGNAR_CONVOY", 3000);
      balanza.estado = 'ASIGNAR_CONVOY';
            // CRISTHIAN MEJORAS FOCUS - BALANZA
           if(this.tipoSelected.tipoEscenario == "COMPRA" || this.tipoSelected.tipoEscenario == "INFORMATIVO"){
              this.utilServices.mensajeOKToast("Balanza Salida, pasará a CONVOY_PLANIFICADO", 3000); // borrar
              balanza.estado = 'CONVOY_PLANIFICADO';
           }

           if(this.tipoSelected.tipoEscenario == "VENTA" && this.selected.tipoCarga == 2){
              this.utilServices.mensajeOKToast("Balanza Salida, pasará a ASIGNAR_SELLOS", 3000); // borrar
              balanza.estado = 'ASIGNAR_SELLOS';
           }
    }

    if(this.ordenBalanza.estado == 'BLOQUEADO_POR_PESOS'){
      this.utilServices.mensajeOKToast("Balanza Con diferencias, pasará a BALANZA_IN", 3000);
      balanza.estado = 'BALANZA_IN';
    }

    console.info("estado, formBalanza, validacion pesos",this.ordenBalanza.estado, this.formBalanza.invalid, this.validadoPesos);

    const payload = balanza;
    this.utilServices.confirmarSincronoPromesa({
        title   : diccionarios.mensajes.actualizar,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.logisticaAPI.updateViajeBalanza(payload)
      }).then((response : ITrackingViajes) => {

        this.logisticaAPI.updateNextViajeCola(response.areaId, this.usarioActual.login2).subscribe((res) => {
            this.utilServices.alertatoastOK("Viaje Habilitado " + res.idViaje);
        });
        
        if(this.basculaUsuario?.sensorId != null){
          this.utilServices.mensajeOKToast("Seteando sentido y enviando marquesina", 2000);
          this.enviarMensajeMarquesina(response.estado);
        }

        this.closeModal();
        this.listar();

      }).catch(() => {});

      this.loading = false;
  }

  acciones(event) {
    if (event === 'regresar') {
      this.isCreate = false;
      this.selected = null;
      this.conexionSensores = false;
      return this.closeModal();
      return this.ngOnInit();
    }

    if(!this.isBalanza){
      this.saveForm();
    }else{
      this.saveFormBalanza();
    }

  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    //T.42031 RF: 2.1
    if(this.isBalanza) return document.getElementById('cerrarModalBalanza').click();

    document.getElementById('cerrarModal').click();
  }

  onKeydown(event) {
    console.log(event);

    if ((event.key === 'Enter' && this.formulario.valid === true)){
        console.log('ENTER --> KEYDOWN');
      }

  }

  /** Evita que el formulario se envíe al presionar Enter y cause recarga de la página */
  onKeydownEnter(event: Event) {
    // Evitar que la tecla Enter cause un envío de formulario predeterminado
    event.preventDefault();
    // Si quieres que el Enter guarde el formulario, puedes llamar a saveForm() aquí
    // pero por ahora solo prevenimos la recarga
  }

  /** Maneja el ngSubmit del formulario para prevenir la recarga de la página */
  onFormSubmit(event: Event) {
    event.preventDefault();
  }

  /** METODOS DE CONSULTAS  */
  proveedorSelected;// no se usa esta variable borrar
  getProveedor(esProvTransporte:boolean = true){
    let pathParam = this.formulario.get('proveedorId').value;
    //this.proveedorSelected = null;
    if(!esProvTransporte){ // Operaciones para proveedor de compra
      pathParam = this.formulario.get('compras.proveedorCompra').value;
      console.log("proveedor de compra", pathParam);

      this.listOrigen = this.listOrigenAll.filter(item => item.proveedor == pathParam);
      this.formulario.get('compras.proveedorCompraName').reset();
    }else{
      this.formulario.get('proveedorNombre').reset();
    }

    this.dmaestrosAPI.getProveedorByID(pathParam).subscribe((res) => {
      if(res){
        //this.proveedorSelected = res;
        if(esProvTransporte){
          this.formulario.get('proveedorNombre').setValue(res.nombre);
        }else{
          // proveedor compra
          this.formulario.get('compras.proveedorCompraName').setValue(res.nombre);
          console.log("caso para proveedor de compra");
        }
      }else{
        this.utilServices.alertifyToast("No se encontró registro de proveedor" + pathParam);
      }
    }, (err) => {
      console.log(err.message);
    });
  }

  clienteSelected;
  getCliente(){
    let pathParam = this.formulario.get('cliente').value;

    this.formulario.get('clienteNombre').reset();
    this.dmaestrosAPI.getClienteId(pathParam).subscribe((res) => {
      if(res){
        this.clienteSelected = res;
        this.formulario.get('clienteNombre').setValue(res.nombreCliente1);;
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
        this.clienteSelected = null;
      }
    }, (err) => {
      console.log(err.message);
    });
  }


  // En la tabla de placas se encuentra tanto el Furgon como la Placa de cabezal
  async getPlaca(isPlaca: boolean = true){
    let pathParam = isPlaca ? this.formulario.get('placa').value : this.formulario.get('furgon').value;

    if(isPlaca){
      this.formulario.get('proveedorId').reset();
      this.formulario.get('detallePlaca').reset();
    }else{
      this.formulario.get('detalleFurgon').reset();
    }

    try {
      const res: any = await this.dmaestrosAPI.getPlacabyId(pathParam).toPromise();
      if(res){
        if(isPlaca){
          this.formulario.get('proveedorId').setValue(res.cedula);
          this.formulario.get('detallePlaca').setValue(res.marca);
          this.getProveedor();
          await this.getTiposRecursos();
          await this.getFurgones();
        }else{
          this.formulario.get('detalleFurgon').setValue(res.marca);
        }
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
      }
    } catch (err) {
      console.error(err.message);
    }

  }

  getPlacas(idTransportista: string) {
    this.placasLoading = true;
    this.placas = [];
    this.logisticaAPI.getPlacas(idTransportista).subscribe((res: any) => {
      this.placas = res;
      this.placasLoading = false;
    }, (err) => {
      console.error(err.message);
      this.placasLoading = false;
    });
  }

  listChoferes
  getChofer(){
    //let pathParam = this.formulario.get('choferCedula').value;
    //this.formulario.get('choferNombre').reset();

    let pathParam = this.formulario.get('choferNombre').value;
    let proveedor = this.formulario.get('proveedorId')?.value; //T.42031 RF: 1.6 1.7
    this.dmaestrosAPI.getChoferSearchNombres(pathParam, proveedor).subscribe((res: Chofer[]) => {
      if(res){
        this.listChoferes = res.filter(a=> this.listChoferesDisponibles.some(b => b.cedula === a.cedula));
      }else{
        this.utilServices.mensajeOKToast("No se encontró registro", 3000);
      }
    }, (err) => {
      console.log(err.message);
    });
  }

  listAgenciasDestino= [];

  onChangeCentroOrigen( data : any){
    console.log("onChangeCentroOrigen");
    console.log(data);
  }

  onFechaLlegadaChange() {
    console.log("Fecha planificada de llegada:", this.formulario.get('fechaLlegada').value);
  }

  getAlmacen(esOrigen: boolean = true){
    console.log("-> getAlmacen");
    const aplicaSeteoAlmacen =  (this.tipoSelected.tipoEscenario == 'TRASLADO' || this.tipoSelected.tipoEscenario == 'VENTA');

    const pathParam =  esOrigen ? this.formulario.get('centroOrigen').value : this.formulario.get('centroDestino').value;
    if(esOrigen)
      this.listAgencias = [];
    else this.listAgenciasDestino = [];

    this.dmaestrosAPI.getAllAlmacenByCentro(pathParam).subscribe((res) => {
      if(res){
        let almacenes = res.map(e => {e.dscaAlmacen = e.idAlmacen + ' - ' + e.dscaAlmacen; return e;});
          if(esOrigen) this.listAgencias = almacenes;
          
          if(!esOrigen && !aplicaSeteoAlmacen){ 
            this.listAgenciasDestino = almacenes;
          }else{
            this.listAgenciasDestino = this.ensureAlmacenDestinoPT01(almacenes);
          }
      }
    }, (err) => {
      console.log(err.message);
    });

  }

  private ensureAlmacenDestinoPT01(list: any[]): any[] {
    const almacenes = Array.isArray(list) ? list : [];
    const pt01 = almacenes.find((e: any) => String(e?.idAlmacen ?? '').trim().toUpperCase() === 'PT01');
    const only = pt01
      ? [pt01]
      : [{ idAlmacen: 'PT01', dscaAlmacen: 'PT01 - PRO-TERMINADO' }];

    const current = this.formulario?.get('almacenDestino')?.value;
    const shouldSet = String(current ?? '').trim().toUpperCase() !== 'PT01';
    if (shouldSet) {
      this.formulario?.get('almacenDestino')?.setValue('PT01', { emitEvent: false });
    }
    return only;
  }

  public listTipoTransporte : Array<{ clave: string, valor: string }> = [];
  async getTiposRecursos(){
    const pathParam = this.formulario.get('proveedorId').value;
    this.listTipoTransporte = [];

    try {
      const res = await this.dmaestrosAPI.getTransportesByRecurso(pathParam).toPromise();
      if(res){
        this.listTipoTransporte = res.map((item: string) => ({ clave: item, valor: item }));
      }
    } catch (err) {
      console.info("No se encontro tipos de recurso", err.message);
    }
  }

  public recursos;
  async getFurgones(){
    const pathParam = this.formulario.get('proveedorId').value;
    this.recursos = [];

    try {
      const res: any = await this.dmaestrosAPI.getFurgonByRecurso(pathParam).toPromise();
      if(res){
        this.recursos = res;
        this.recursos.map(items => items.marca = items.placa + ' - ' + items.marca);
      }
    } catch (err) {
      console.info("No se encontro furgones", err.message);
    }
  }

  getFurgonesFilter(){
    const tipoTrans = String(this.formulario.get('tipoRecurso').value || '').trim();
    const proveedor = this.formulario.get('proveedorId').value;
    //if(!tipoTrans){
      console.log("tess1->" ,tipoTrans);
      console.log("tess2->" ,this.recursos);
      
      //T.42031 1.2 furgones solo disponibles no ocupados en planificacion
      if(tipoTrans == "Furg"){
        this.logisticaAPI.getFurgonesDisponibles(proveedor).subscribe((res) => {
          this.listFurgones = res;
          this.listFurgones.map(items => items.marca = items.placa + ' - ' + items.marca);
        }, (err) => {
          console.info("No se encontró furgones disponibles", err.message);
        });
        return;
      }

      this.listFurgones = this.recursos.filter(e=> e.tipoTransporte == tipoTrans);
      console.log("tess3->" ,this.listFurgones);
    //}
  }

  async getFurgonByCodePlaca(){
    const placa = String(this.formulario.get('furgon').value || '');
    if(!placa) return;

    if(!this.recursos || this.recursos.length === 0){
      await this.getFurgones();
    }

    const recurso = this.recursos?.find(e=> e.placa == placa);
    if(recurso){
      this.formulario.get('tipoRecurso').setValue(recurso.tipoTransporte);
      this.formulario.get('tipoRecurso').updateValueAndValidity();
    }

    this.getFurgonesFilter();

    const existsInLista = this.listFurgones?.some(e => e.placa == placa);
    if(!existsInLista){
      if(recurso){
        this.listFurgones = [...(this.listFurgones || []), recurso];
      } else if (this.permiteDigitarFurgon) {
        const detalle = this.formulario.get('detalleFurgon')?.value;
        this.listFurgones = [...(this.listFurgones || []), this.tagFurgonManualEdicion(placa, detalle)];
      }
    }

    this.formulario.get('furgon').setValue(placa);
    this.formulario.get('furgon').updateValueAndValidity();
  }

  placaSelected;
  async actualizarEstado({rowData}){
    this.placaSelected = rowData.placa;
    rowData.estado = 1;
    const data = rowData;
    await this.getUsuarioBasculaGarita();
    //this.selected = rowData;
    this.utilServices.confirmarSincronoPromesa({
        title   : "¿Esta seguro que desea enviar a REVISIÓN GARITA el viaje?",
        text    : 'VIAJE ' + rowData.idViaje,
        action  : "Actualizar Viaje",
        funcion : this.logisticaAPI.updateViaje(data)
      }).then((response: ITrackingViajes) => {
        this.loading = false;
        this.listar();

        if(this.basculaUsuario?.sensorId != null){
          this.utilServices.mensajeOKToast("Seteando sentido y enviando marquesina", 2000);
          this.enviarMensajeMarquesina(response.estado);
        }

        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });
  }

  ordenBalanza : IOrdenBalanza; // Automaticamente trae por el número del ticket de garita
  getOrdenBalanza(){
    this.ordenBalanza = null;
    const valorBuscar = this.selected.garitaTicket;

    this.ticketGaritaApi.validaDuplicidadTicket(valorBuscar).subscribe((res: IOrdenBalanza) => {
      if(res[0]){
        this.ordenBalanza = res[0];
        this.validadoPesos = true;
        this.formBalanza.get('pesoIn').setValue(this.ordenBalanza.pesoIn);
        this.formBalanza.get('pesoOut').setValue(this.ordenBalanza.pesoOut);
        this.formBalanza.get('estadoOB').setValue(this.ordenBalanza.estado);
        this.formBalanza.get('balanzaTicket').setValue(this.ordenBalanza.idOrden);
        //this.formBalanza.get('fSalidaGarita').setValue(this.ordenBalanza.authTransp?.fechaSalida);;
        if(this.ordenBalanza.estado == 'ANULADA' || this.ordenBalanza.estado == 'INACTIVO') this.utilServices.mensajeErrorVisto("OB Eliminada o Anulada favor revisar", false, 3000);
        if(this.selected.estado == 'BALANZA_OUT' && this.formBalanza.get('pesoOut').value == null) {
            this.utilServices.mensajeErroToast("OB requiere peso salida. Solicite a operador de Kosmos-Balanza");
            this.validadoPesos = false;
          }
        //if(this.selected.estado == 'BLOQUEADO_PESOS') this.utilServices.mensajeErrorVisto("OB bloqueada. Solicite aprobación operador de Kosmos-Balanza", false, 3000);
      }else{
        console.info("Sin datos de OB", this.ordenBalanza);
      }
    }, (err) => {
      console.log(err.message);
    });
  }

  getFormValidationErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;
    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
    console.log('Number of errors: ', totalErrors);
  }

  closeModalBalanza() {
    document.getElementById('cerrarModalBalanza').click();
  }

  /**PROCESO DE BALANZA
   * FORM Y ACCIONES EXCLUSIVOS PARA BALANZA
   */
  //this.formBalanza.get('estado').setValue("BALANZA_OUT");
  validadoPesos: boolean = true;
  procesoBalanza({rowData}){
    this.titleModal = this.DAT_TITULOS.tituloCardList;
    this.fechaHoraInicio = this.utilServices.getFechayHoraActual();
    this.isCreate   = (rowData.balanzaTicket == 0 || rowData.balanzaTicket == null); // si es 0 no existe ticket de balanza actualmente registrado
    this.selected   = rowData;
    this.validadoPesos = true; //siempre true en new ticket, se valida con la existencia de ticket y si posee o no peso de salida
    this.formBalanza.reset();

    //PROCESO AMPLIADO DE TRACKING
    this.tipoSelected   = this.listTipos1.find(e=> e.idTipo == rowData.tipo);
    console.log("tipo de orden seleccionada", this.tipoSelected);

    //const estado = rowData.estado == 'GARITA_APROBADO' ? 'BALANZA_IN' : 'ASIGNAR_CONVOY'; // REORDENAR ESTADOS CESAR Y CRISTHIAN
    //const estado = (rowData.estado == 'REVISION_ACEPTADA' || rowData.estado == 'REVISION_CONDICIONADA') ? 'BALANZA_IN' : 'ASIGNAR_CONVOY';
    const estado = this.getStatusTransitoyPesaje(rowData.estado, this.tipoSelected.generaTicketBalanza);
    console.log("estado a migrar", estado);

    //VALORES PARA EL FORMULARIO DE PESOS BALANZA
    this.formBalanza.get('pesoOut').setValidators([]);
    this.formBalanza.patchValue(rowData);
    this.formBalanza.get('modificadoPor').setValue(this.usarioActual.login2);
    this.formBalanza.get('estado').setValue(estado);

    if(!this.isCreate || (rowData.tipoCarga == 1 && rowData.tipoCarga != 0)){
      this.utilServices.alertifyToastOK("Viaje ya cuenta con valores de balanza");
      console.info("Contenerizado con ticket de Garita previamente lleno y no generacion automatica" );
      this.getOrdenBalanza();
    };

    //Solicite a operador de Kosmos-Balanza
    if(rowData.estado == 'BALANZA_OUT') {
      this.formBalanza.get('pesoOut').setValidators([Validators.required]);
      this.formBalanza.get('pesoOut').updateValueAndValidity();
    };

    document.getElementById('fillOne').click();

    //SE DIFERENCIA ESTADO POR SE PLANIFICACION PERMITE GENERAR TICKET AUTOMATICO
    // CRIS analizar, que pasa si el proceso de ventas contenerizado aplica a la configuracion de generaTicket, ahí se rompe el proceso
    if(this.tipoSelected.generaTicketBalanza){
        //this.formBalanza.get('estado').setValue('REVISION_CALIDAD_HABILITADA');
        this.permiteCapturaPeso = this.isCreate;
        this.getUsuarioBasculaGarita();
    }

  }


/**
 * Ajustes Ticket T.32832
 * ampliación del proceso de planificacion y tracking
 * Escenarios COMPRA, TRASLADOS. VENTA, INFORMATIVOS
 * add controles y aplicar restricciones dinamicas
 * Se diferencia por que son de tipo granel
 */
  getAreas(){
    //const pathParam = this.formulario.get('centroDestino').value;
    let controlArea = (this.tipoCarga == 2 && this.tipoSelected.tipoEscenario == 'VENTA');
    const pathParam = controlArea ? this.formulario.get('centroOrigen').value : this.formulario.get('centroDestino').value;
    this.listAreas = [];
    if (pathParam) {
      this.trackingConfiguracional.getAreasbyCentro(pathParam).subscribe((res) => {
      if(res) {
        let areas = res.map(e => {e.descArea = e.nomeclatura + ' - ' + e.descArea; return e;});
        this.listAreas = this.isCreate ? areas.filter(e=> e.estado == 'A') : areas;
      }
    }, (err) => {
      console.log(err.message);
    });
    }

  }

  private manejarControlCompras(valorTipo: string) {
    if (valorTipo == 'COMPRA' || valorTipo == 'INFORMATIVO') {
        if (!this.formulario.get('compras')) {
            this.formulario.addControl('compras', this.addFieldNuevos());
        }
    } else {
        if (this.formulario.get('compras')) {
            this.formulario.removeControl('compras');
        }
    }


    // 2. Lógica para manejar el campo requerido en 'centroOrigen' y 'bodegaCarga' en COMPRA
    const centroOrigenControl = this.formulario.get('centroOrigen');
    const bodegaCargaControl = this.formulario.get('bodegaCarga');

    if (centroOrigenControl && bodegaCargaControl) {
      if (valorTipo == 'COMPRA') {
        centroOrigenControl.setValidators([]);
        bodegaCargaControl.setValidators([]);
      } else {
        centroOrigenControl.setValidators([Validators.required]);
        bodegaCargaControl.setValidators([Validators.required]);
      }

      centroOrigenControl.updateValueAndValidity();
      bodegaCargaControl.updateValueAndValidity();
    }

    if(this.tipoSelected) this.requiereFields();
  }

  private addFieldNuevos(): FormGroup{
    return this.fbServices.group({
        proveedorCompra     : [''],
        proveedorCompraName : [''],
        extractoraId        : [''],
        extractoraAcidez    : [''],
        extractoraHumedad   : [''],
        extractoraImpureza  : [''],
      });
  }

  requiereFields() {
    const camposPorTipo = this._catalogos.fieldbyType;
    const camposRequire = camposPorTipo[this.tipoSelected.tipoEscenario] || [];
    console.log("Detalles validaciones para los campos de: ", camposRequire);

    //Limpia validadores a todos los campos condicionados por tipo //this._catalogos.fieldbyType
    for(const campos of Object.values(camposPorTipo)) {
      for (const ruta of campos) {
        const control = this.formulario.get(ruta);
        if (control) {
          control.reset();
          control.clearValidators();
          control.updateValueAndValidity({ emitEvent: false });
        }
      }
    }

    //Agrega validadores a campos por tipo de escenario, sea compra, venta, traslado etc
    console.log("Aplicaciones para ===>", this.tipoSelected.tipoEscenario);
    camposRequire.forEach(e=> {
      const control = this.formulario.get(e);
      if (control) {
        control.addValidators(Validators.required);
          if(!this.tipoSelected.requiereBuque && e == 'buque') control.clearValidators(); // ventas
          if(!this.tipoSelected.requiereOrden && e == 'orden') control.clearValidators(); // ventas
          if(!this.tipoSelected.requiereOrigen && e.includes('compras.extractora')) { // compras y origenes
            console.log("no requiere campos de extractora ===>", e);
            control.clearValidators()
          };

          if(!this.tipoSelected.generaTicketBalanza) control.clearValidators();
          if(!this.tipoSelected.requiereArea && e == 'areaId') control.clearValidators(); // todos

          control.updateValueAndValidity({ emitEvent: false });
        }
    });
    //this.formulario.updateValueAndValidity();
  }


  //Obtiene el usuario para garita o bascula
  basculaUsuario : any;
  async getUsuarioBasculaGarita(){
    const username =this.usarioActual.login2;
    this.usuarioBasculaAPI.obtenerPorUsuario(username, "bascula").subscribe(
      resp => {
        if (resp?.bascula) {
          let bascula = {
            idBascula: resp.bascula,
            estado: resp.estadoBascula,
            desca: resp.basculaDescripcion,
            sensorId: resp.sensorId,
            apiKey: resp.apiKey,
          };
          this.basculaUsuario = bascula;

          //Verifica test de conexión siempre que tenga Api Key
          if (resp.sensorId != null) {
            this.onlyControlSensoresAPI.setIntegration_ApiKey(resp.sensorId);
            this.conexionSensores = true;
            this.getOnlyStatusConexion();
          }

          return;
        }
        this.utilServices.mensajeErrorVisto("Usuario no tiene Bascula asignada", true, 5000, "Configuración en balanza");
      },
      e => {console.error('Mensaje: ', e.error.mensaje, 'Respuesta', e.error.respuesta);}
    );
  }

 cmbTipoOrden;
  async getTipoOb(){
 // this.cmbTipoOrden = [];
   this.tipoOrdenesBalanzaS.obtener().subscribe(
    (resp) => {
      this.cmbTipoOrden = resp;
    },
    (e) => {});
 }

 crearOB(){
  const tipoEscenario = this.tipoSelected.tipoEscenario;
  let pesoCapturado: Number = 0;
  //pesoCapturado = this.selected.estado == 'BALANZA_IN' ? this.formBalanza.get('pesoIn').value :  this.formBalanza.get('pesoOut').value;
  //pesoCapturado = this.formBalanza.get('estado').value == 'BALANZA_IN' ? this.formBalanza.get('pesoIn').value :  pesoCapturado = this.formBalanza.get('pesoOut').value;
  const compruebaEstado = this.getStatusTransitoyPesaje(this.selected.estado, true);
  pesoCapturado = this.statusPesajeIn ? this.formBalanza.get('pesoIn').value : this.formBalanza.get('pesoOut').value;

  console.log("comprueba estado", compruebaEstado);
  console.log("this.selected.estado->", this.selected.estado);
  console.log("this.formBalanza.get('estado').value->", this.formBalanza.get('estado').value);
  console.log("pesoCapturado->", pesoCapturado);
  if(this.basculaUsuario == null) return this.utilServices.alertifyToastWar("Usuario No tiene bascula asignada");
  if(pesoCapturado == 0 || pesoCapturado == null) return this.utilServices.alertifyToastWar("Se requiren peso para continuar");

  let payload : IOrdenBalanza = {
    estado      : "INGRESADA",
    tipoOrden   : this.cmbTipoOrden.find(e=>e.id == this.selected.tipoOrdenBalanza),
    ordenCompra : {idOrd: 0, mat: this.selected.materialId, fecha: this.utilServices.getFechayHoraActual()},
    numOrdAlt   : this.selected.orden,
    proveedor   : this.selected.proveedorCompra,
    cliente     : this.selected.cliente,
    //ordBalanzaOrigen :
    //pesoBalanzaOrigen
    sellos      : this.selected.sellos,
    //contenedor :
    authTransp  : { idAuthTransp: this.selected.garitaTicket, proveedorTransp: this.selected.proveedorId},
    proveedorTransp : Number(this.selected.proveedorId),
    placa       : this.selected.placa,
    cedChofer   : this.selected.choferCedula,
    centroOri   : this.selected.centroOrigen,
    almanceOri  : this.selected.bodegaCarga,
    centroDest  : this.selected.centroDestino,
    almaceDest  : this.selected.almacenDestino,

    pesoIn    : this.formBalanza.get('pesoIn').value,
    fechIn    : this.utilServices.getFechayHoraActual(),

    //Por lo dinamico del proceso se mantiene en salida
    /*pesoOut   : 0,
    fechOut   : 0, */

    pesoNeto  : this.selected?.extractoraPesoNeto, 
    pesoBruto : this.formBalanza.get('pesoIn').value, // Cris dice pasar en este campo peso in

    idusuario : this.usarioActual.login,
    //vehiculoVacio : this.selected.aplicaSalidaDevolucion,
    bascula     : this.basculaUsuario,
    /*tara        : null, // Se agregan solo si el escaneario es compra
    acidez      : null,
    humedad     : null,
    impureza    : null,
    origOrd     : null*/
    material : this.selected.materialId,
    fecha    : this.utilServices.getFechayHoraActual(),
  };

  // Cris indica que todo compra, llenar según los valores
  if(tipoEscenario == 'COMPRA'){
    payload.tara      = this.selected.extractoraPesoTara,
    payload.pesoBruto = this.selected.extractoraPesoBruto,
    payload.pesoNeto  = this.selected.extractoraPesoNeto,

    payload.acidez    = this.selected.extractoraAcidez,
    payload.humedad   = this.selected.extractoraHumedad,
    payload.impureza  = this.selected.extractoraImpureza,
    payload.origOrd   = Number(this.selected.extractoraId)
  }

  this.utilServices.confirmarSincronoPromesa({
      title   : "Crear Orden de Balanza",
      text    : "Se creará una Orden de Balanza automatica",
      action  : "Nueva OB",
      funcion : this.balanzaAPI.crearOrdenBalanza(payload),
    }).then((res: IOrdenBalanza) => {
        this.ordenBalanza = res;
        this.formBalanza.get('pesoIn').setValue(this.ordenBalanza.pesoIn);
        this.formBalanza.get('pesoOut').setValue(this.ordenBalanza.pesoOut);
        this.formBalanza.get('estadoOB').setValue(this.ordenBalanza.estado);
        this.formBalanza.get('balanzaTicket').setValue(this.ordenBalanza.idOrden);
        this.loading = false;

        this.enviarMensajeMarquesina(res.estado);
    }).catch((error) => {
      console.log(error.error);

      if(error.error.respuesta){
        this.ordenBalanza = error.error.respuesta;
        this.formBalanza.get('pesoIn').setValue(this.ordenBalanza.pesoIn);
        this.formBalanza.get('pesoOut').setValue(this.ordenBalanza.pesoOut);
        this.formBalanza.get('estadoOB').setValue(this.ordenBalanza.estado);
        this.formBalanza.get('balanzaTicket').setValue(this.ordenBalanza.idOrden);
      }

      //this.enviarMensajeMarquesina("OB_ERROR");
    });
 }

  permiteCapturaPeso: boolean = false;
  getCapturarPeso() {
    const username =this.usarioActual.login2;
    this.balanzaAPI.obtenerPesoByUser(username).subscribe(
      (resp) => {
        console.log("Peso Capturado", resp);
        //this.formBalanza.get('pesoIn').setValue(resp.peso);
        this.formBalanza.get('pesoIn').setValue(resp.pesoNeto); //cambio de la etiqueta del objeto de peso a pesoNeto
      },
      (error) => {}
    );
  }

  public bitacora = [];
  getBitacora({rowData}){
    const viaje = rowData.idViaje;
    this.logisticaAPI.getBitacoraByViaje(viaje).subscribe(
      (resp) => {
        this.bitacora = resp;
      },
      (error) => {}
    );
  }

  resetBitacora(){
    this.bitacora = [];
  }

  statusPesajeIn: boolean = false;
  getStatusTransitoyPesaje(estadoDataSelected, isCheckenPartes): string {
    const estadoActual = this.formBalanza.get('estado').value;
    this.statusPesajeIn = (estadoActual == 'BALANZA_IN' || estadoActual == 'REVISION_CALIDAD_HABILITADA' || estadoActual == 'REVISION_OPERADOR_HABILITADA');

    console.log("estado actual", estadoActual);
    console.log("permite ticket balanza automatico", isCheckenPartes);
    console.log("es balanza entrada", this.statusPesajeIn);

    if(isCheckenPartes && this.selected.tipoCarga == 2){
      return (estadoDataSelected == 'REVISION_ACEPTADA' || estadoDataSelected == 'REVISION_CONDICIONADA') ? 'REVISION_CALIDAD_HABILITADA' : 'ASIGNAR_CONVOY';

    }else{
      let estadoRetornoPTA = (estadoDataSelected == 'REVISION_ACEPTADA' || estadoDataSelected == 'REVISION_CONDICIONADA') ? 'BALANZA_IN' : 'ASIGNAR_CONVOY';
      let estadoRetornoMPR = (estadoDataSelected == 'REVISION_ACEPTADA' || estadoDataSelected == 'REVISION_CONDICIONADA') ? 'REVISION_OPERADOR_HABILITADA' : 'ASIGNAR_CONVOY';

      if(isCheckenPartes && this.selected.tipoCarga == 1) return estadoRetornoMPR;        
      return estadoRetornoPTA;
    }

  }


  //Choferes Disponibles, por logistica y convoys cerrados
  listChoferesDisponibles;
  getChoferDisponibles(){
    const proveedor = this.formulario.get('proveedorId').value;
    this.logisticaAPI.getChoferesDisponibles(proveedor).subscribe((res) => {
      this.listChoferesDisponibles = res;
    }, (err) => {
      console.info("No se encontró proveedores disponibles", err.message);
    });

  }


  /**INTEGRACION ONLY CONTROL
   * Equipos y sensores en la entrada de la balanza
   */

  respuestaOnlyControl: IResponseApiOnlyServices<String>;

  getOnlyStatusConexion() {
    this.onlyControlSensoresAPI.getStatuConecc().subscribe(
      (resp) => {
        console.log(resp);
        this.respuestaOnlyControl = resp;
      },
      (error) => {
        this.utilServices.mensajeErrorVisto("Respuesta de conectividad " + this.respuestaOnlyControl.detalle);
      }
    );
  }

  enviarMensajeMarquesina(tipoMensaje: any){
    //let tipoMarquesina = "MAR001 - PUERTA";
    //let setSentido = 0;
    console.log("buscar mensaje según estado", tipoMensaje);
    let filterMnsj = this.mensajesMarquesinas.find(e=> e.tipo === tipoMensaje);
    let lineasMnsj = filterMnsj ? filterMnsj.mensaje.split(",").map(m => ({texto: m.trim()})) : 0;

    /*
    switch (tipoMensaje) {
      case "ENTRADA":
        tipoMarquesina = "MAR001 - PUERTA"
        setSentido = 1;
        break;

      case "BALANZA_IN":
        tipoMarquesina = "MAR002 - BALANZA_IN";
        setSentido = 1;
        break;

      case "BALANZA_OUT":
        tipoMarquesina = "MAR003 - BALANZA_OUT";
        setSentido = 2;
        break;

      case "OB_ERROR":
        tipoMarquesina = "MAR002 - OB_ERROR";
        setSentido = 2;
        break;

      case "OB_OK":
        tipoMarquesina = "MAR002 - OB_OK";
        setSentido = 2;
        break;

      case "OC":
        tipoMarquesina = "MAR003 - OC";
        //seteaSentido = 2;
        break;

      default:
        console.log("MENSAJE no reconocido");
    }*/

    if(filterMnsj.indicador > 0) this.setearSentidoBascula(filterMnsj.indicador);

    if(lineasMnsj.length == 0){
      console.info("Marquesina sin mensajes", lineasMnsj.length);
      this.utilServices.alertifyToastWar("Sin mensajes para marquesina " + filterMnsj.marquesina.codigo);
      return;
    }
    
    if(filterMnsj.marquesina.ubicacion = "PUERTA"){ 
      const last = lineasMnsj.length -1;
      lineasMnsj[last].texto  =  lineasMnsj[last].texto + " " + this.placaSelected;
    }

    const request: IMensajesRequest = {
      codigoBascula     : filterMnsj.marquesina.codigo,
      mensajesMarquesina: lineasMnsj
    };

    this.onlyControlSensoresAPI.postMensaje(request).subscribe(
      (resp) => {
        console.log(resp);
        if(resp.error == 1){
          this.utilServices.mensajeErrorVisto("Error de Envio de mensajes", resp.detalle, 3000);
          return;
        }
        this.utilServices.alertifyToastOK("Mensaje de entrada enviado a la marquesina");
      },
      (error) => {
        this.utilServices.mensajeErrorVisto("Error en establecer mensaje");
        console.log("Error en establecer mensaje", error);
      }
    );
  }

  //Recibe sentido 1 o 2 dependiente si es Entrada o Salida
  setearSentidoBascula(sentido: number){
    const request: IBasculaSentidoRequest = {
      codigoBascula: this.basculaUsuario.sensorId,
      sentido: sentido
    };
    this.onlyControlSensoresAPI.postSentidoBascula(request).subscribe(
      (resp) => {
        this.utilServices.alertifyToastOK("Sentido establecido");
        if(resp.error == 1){
          this.utilServices.mensajeErrorVisto("Error en establicer sentido", resp.detalle, 3000);
          return;
        }
      },
      (error) => {
        this.utilServices.mensajeErroToast("Error en establecer sentido");
        console.log("Error en establecer sentido", error);
      }
    );
  }

  getStatusBascula(balanza:string, sentido: number){
    const request: IBasculaSentidoRequest = {
      codigoBascula: balanza,
      sentido: sentido
    };

    this.onlyControlSensoresAPI.getStatusBasqula(request).subscribe(resp => {
      console.log(resp.fecha);
      console.log(resp.detalle.via_descripcion);
      console.log(resp.detalle.via_ultimo_vehiculo_detectado.vehiculo_placa);
    });
  }

  mensajesMarquesinas=[];
  getAllMensajesMarquesinas(){
    this.logisticaAPI.getMarquesinaMensajes().subscribe(resp => {
      if(resp){
        this.mensajesMarquesinas = resp;
      }
      console.log("mensajes marquesiana", this.mensajesMarquesinas);
    });
  }

  getMensajesMarquesinas(idMarquesina){
    this.logisticaAPI.getMensajesbyMarquesina(idMarquesina).subscribe(resp => {
      if(resp){
        this.mensajesMarquesinas = resp;
      }
      console.log("mensajes marquesiana", this.mensajesMarquesinas);
    });
  }


//Selected de combos de busquedas

clienteSeleccionado(cliente: ClienteShort) {
    this.clienteElegido = cliente;
    console.log('Cliente seleccionado:', this.clienteElegido);
    this.formulario.get('cliente').setValue(this.clienteElegido.idCliente);
    this.formulario.get('clienteNombre').setValue(this.clienteElegido.nombreCliente1);
  }

proveedorSeleccionado(proveedor: any) {
  console.log('Proveedor seleccionado:', proveedor);
  this.formulario.get('proveedorId').setValue(proveedor.idProveedor);
  this.formulario.get('proveedorNombre').setValue(proveedor.nombre);
  this.getPlacas(proveedor.idProveedor);
  this.getTiposRecursos();
  this.getFurgones();
  this.getChoferDisponibles();
}

OnChangePlaca( data : any){
  this.formulario.get('detallePlaca').setValue(data.marca);
}

  buscar(){
    const filtros = this.formFiltro?.getRawValue?.() ?? {};
    const hasAny =
      !!String(filtros?.fechaInicio ?? '').trim() ||
      !!String(filtros?.fechaFin ?? '').trim() ||
      !!String(filtros?.proveedorId ?? '').trim() ||
      !!String(filtros?.centroDestino ?? '').trim() ||
      !!String(filtros?.tipo ?? '').trim();

    if (!hasAny) {
      this.listar();
      return;
    }

    this.loading = true;
    this.rowData = null;

    this.logisticaAPI.searchViajesQuery({
      centroDestino: filtros.centroDestino,
      fechaFin: filtros.fechaFin,
      fechaInicio: filtros.fechaInicio,
      proveedorId: filtros.proveedorId,
      tipo: filtros.tipo,
      orderDesc: true,
      page: 0,
      pageSize: 20,
    }).subscribe((res) => {
      this.rowData = res || [];
      this.loading = false;
    }, (err) => {
      this.loading = false;
      console.log(err.message);
    });
  }

  limpiarFiltros(){
    this.formFiltro?.reset({
      fechaInicio: null,
      fechaFin: null,
      proveedorId: null,
      centroDestino: null,
      tipo: null,
    });
    this.listar();
  }


  imprimirDoc({rowData}){
    this.logisticaAPI.downloadReporteSalida(rowData.idViaje, this.usarioActual.login2).subscribe({
      next: (blob: Blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = `reporte_salida_${rowData.idViaje}.pdf`;
        anchor.click();
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      },
      error: (err) => {
        const message = err?.message || 'No se pudo generar el PDF';
        this.utilServices.mensajeErroToast(message, 3000);
      }
    });
  }


}
